import "core-js/modules/es.array.concat.js";
import _taggedTemplateLiteral from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import { jsx as _jsx } from "react/jsx-runtime";

var _templateObject;

import React from 'react';
import styled from 'styled-components';

var container = function container(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(props.className, " ").concat(props.custom ? 'trakr__container' : ''),
    children: props.children
  });
};

export var Container = styled(container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.fullWidth ? '100%' : 'inherit';
}, function (props) {
  return props.height ? props.height : 'inherit';
});